import {useEffect, useState} from 'react';

export const useIsAppWebView = () => {
  const [isWebView, setIsWebView] = useState(false);
  useEffect(() => {
    const ua = window.navigator.userAgent;
    setIsWebView(
      ua.indexOf('Gaishishukatsu iOS App') > 0 ||
        ua.indexOf('Gaishishukatsu Android App') > 0,
    );
  }, []);
  return isWebView;
};
